import { useCallback, useEffect, useState } from "react";
import { Check, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { Input } from "@/components/ui/input";
import { StudioDati } from "@/components/studio/StudioDati";
import { StudioClienti } from "@/components/studio/StudioClienti";
import { UnisciStudi } from "@/components/studio/UnisciStudi";

const NEW = { id: null, denominazione: "" };

export default function Studios() {
  const [items, setItems] = useState([]);
  const [cur, setCur] = useState(NEW);
  const [tab, setTab] = useState("dati");
  const [q, setQ] = useState("");
  const load = useCallback((selId) => api.get("/admin/studios").then((r) => {
    setItems(r.data);
    if (selId) setCur(r.data.find((s) => s.id === selId) || NEW);
  }), []);
  useEffect(() => { load(); }, [load]);
  const pick = (s) => { setCur(s); setTab("dati"); };
  const list = items.filter((s) => s.denominazione.toLowerCase().includes(q.toLowerCase()));
  const Item = ({ s, label, testid }) => (
    <button type="button" data-testid={testid} onClick={() => pick(s)}
      className={`flex w-full items-center gap-2 border-b border-slate-100 px-4 py-2.5 text-left text-sm transition-colors hover:bg-sky-50 ${cur.id === s.id ? "bg-sky-50 font-bold text-slate-900" : "text-slate-700"}`}>
      {s.id ? <Check className="h-4 w-4 text-slate-500" /> : <Plus className="h-4 w-4 text-sky-600" />}{label}
    </button>
  );
  return (
    <div>
      <PageHeader title="Studi commercialisti" subtitle="Crea lo studio, il suo accesso e scegli le aziende clienti assegnate" />
      <div className="grid gap-5 lg:grid-cols-[340px_1fr]">
        <div className="space-y-4">
          <div className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">Cerca</div>
            <Input data-testid="studio-search" placeholder="Nome dello studio" value={q} onChange={(e) => setQ(e.target.value)} />
            <div className="mt-3"><UnisciStudi onDone={() => { setCur(NEW); load(); }} /></div>
          </div>
          <div className="overflow-hidden rounded-xl border border-slate-200 bg-white" data-testid="studios-list">
            <div className="border-b border-slate-200 px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Seleziona uno studio</div>
            <Item s={NEW} label="Nuovo studio" testid="add-studio-button" />
            {list.map((s) => <Item key={s.id} s={s} label={`${s.denominazione} (${s.companies})`} testid={`studio-row-${s.id}`} />)}
          </div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <div className="mb-4 flex gap-1 border-b border-slate-200">
            {[["dati", "Dati studio"], ["clienti", "Clienti assegnati"]].map(([k, l]) => (
              <button key={k} type="button" data-testid={`studio-tab-${k}`} disabled={k === "clienti" && !cur.id} onClick={() => setTab(k)}
                className={`-mb-px rounded-t-md border px-4 py-2 text-sm font-medium transition-colors disabled:opacity-40 ${tab === k ? "border-slate-200 border-b-white bg-white text-sky-700" : "border-transparent text-slate-600 hover:text-slate-900"}`}>{l}</button>
            ))}
          </div>
          {tab === "dati" ? <StudioDati studio={cur} onSaved={(id) => load(id)} onDeleted={() => { setCur(NEW); load(); }} />
            : <StudioClienti studio={cur} onSaved={() => load(cur.id)} />}
        </div>
      </div>
    </div>
  );
}
